import { render, staticRenderFns } from "./UcWorksheetData.yaml?vue&type=template&id=6a1f866e&component"
import script from "./UcWorksheetData.yaml?vue&type=script&lang=ts&component"
export * from "./UcWorksheetData.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports